/**
 * Home page content registry.
 * Maps tab identifiers to lazy-loadable content components keyed by locale.
 *
 * @module pages/home/homeContentRegistry
 */

const homeContentRegistry = [
  {
    tab:  'overview',
    load: {
      en: () => import('./content/en/OverviewTab'),
    },
  },
  {
    tab:  'getStarted',
    load: {
      en: () => import('./content/en/GetStartedTab'),
    },
  },
  {
    tab:  'monitor',
    load: {
      en: () => import('./content/en/MonitorTab'),
    },
  },
  {
    tab:  'blog',
    load: {
      en: () => import('./content/en/BlogTab'),
    },
  },
];

export default homeContentRegistry;
